import React, {useEffect, useState} from 'react'
import {addApolloState, initializeApollo} from 'helpers/ApolloHelper/ApolloHelper'
import withAppInit from '_app/hoc/withAppInit'
import {Context} from '_app/types/context'
import {useRouter} from '../../_app/hooks/useRouter'
import {GET_BLOG_POST_BY_URL} from '../../_app/graphql/queries/blog/GetBlogPost'
import ImageHelper from '../../helpers/ImageHelper/ImageHelper'
import PostMagento from '../../modules/blog/PostMagento'
import {GET_BLOG_LIST} from '../../_app/graphql/queries/blog/GetBlogList'
import LocalStorageHelper from '../../helpers/LocalStorageHelper/LocalStorageHelper'
import I18nHelper from '../../helpers/I18nHelper/I18nHelper'
import {URL_RESOLVER} from '../../_app/graphql/queries/URLResolver'

const BlogPost = () => {
    const router = useRouter()
    const {locale} = useRouter()
    const apolloClient = initializeApollo(null, { locale })
    const [post, setPost]: any = useState(null)
    const [relatedPostsNew, setRelatedPostsNew]: any = useState(null)
    const [loading, setLoading]: any = useState(true)
    const getPostNew = async () => {
        const urlKey = router.asPath.split('?')[0].replace(/^\/?(pl\/)?blog\//, '').replace(/\.html$/, '')
        const {data}: any = await apolloClient.query({
            query: GET_BLOG_POST_BY_URL,
            variables: {
                urlKey,
            },
        })
        const newDataTemp = data?.mpBlogPosts?.items[0]
        ImageHelper.checkImage(newDataTemp?.image, (isValid: boolean | ((prevState: boolean) => boolean)) => {
            let postTemp: any = newDataTemp
            const tempTopics: any = []
            newDataTemp?.topics?.items?.forEach((el: { name: any }) => {
                tempTopics.push(el?.name)
            })
            const splitDate = newDataTemp?.updated_at?.split(' ')
            postTemp = {
                category: newDataTemp?.categories?.items?.[0]?.name,
                cover_image: newDataTemp?.image,
                author: newDataTemp?.author_name,
                date: splitDate && `${splitDate[0]?.split('-')[2]}-${splitDate[0]?.split('-')[1]}-${splitDate[0]?.split('-')[0]}`,
                sections: newDataTemp?.post_content,
                title: newDataTemp?.name,
                url_key: newDataTemp?.url_key,
                post_id: newDataTemp?.post_id,
                topics: tempTopics,
                products: newDataTemp?.products?.items,
            }
            setPost(postTemp)
        })
    }
    const getRelatedPostNew = async () => {
        let store: number = 1
        switch (locale) {
            case 'pl':
                store = 1
                break
            case 'fr':
                store = 3
                break
            case 'en':
                store = 2
                break
            case 'de':
                store = 4
                break
        }
        const { data }: any = await apolloClient.query({
            query: GET_BLOG_LIST,
            variables: {
                currentPage: 1,
                pageSize: 4,
                action: 'get_related_post',
                postId: post?.post_id,
                storeId: store,
            },
        })
        setRelatedPostsNew(data?.mpBlogPosts?.items)
    }
    useEffect(() => {
        if (post?.category) {
            getRelatedPostNew()
        }
    }, [post?.category])
    useEffect(() => {
        if (locale) {
            getPostNew()
        }
    }, [locale])
    useEffect(() => {
        if ((post) && relatedPostsNew) {
            setLoading(false)
        }
    }, [post, relatedPostsNew])
    return (
        <>
            {
                !loading && (
                    <PostMagento post={post} relatedPostsNew={relatedPostsNew} />
                )
            }
        </>
    )
}

export const getServerSideProps = withAppInit(async (ctx: Context) => {
    const {urlKey} = ctx?.query
    const apolloClient = initializeApollo(null, { locale: ctx.locale })
    const dataURL = await apolloClient.query({
        query: URL_RESOLVER,
        variables: {
            url: `blog/${urlKey}.html`,
        },
    })
    const url = dataURL?.data?.resolveCustomRedirect?.target_path
    const statusCode = Number(dataURL?.data?.resolveCustomRedirect?.redirect_type)
    if (url && (statusCode === 301 || statusCode === 302)) {
        return {
            redirect: {
                destination: `/${url}`,
                statusCode: statusCode || 301,
            },
        }
    }
    return addApolloState(ctx.apolloClient, {
        props: {
            ...(await I18nHelper.getI18nProps(ctx, ['blog'])),
        },
    })
})

export default BlogPost
